import OCGatewayClient from "../client/OCGatewayClient";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Device } from "../models/Device";

/** Pins the device's idle screen style; `null` returns it to the fleet default. */
export function useDeviceScreenTemplateMutation(deviceId: string) {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (screenTemplate: string | null) => {
            await OCGatewayClient.request('updateDeviceScreenTemplate', {
                deviceId,
                screenTemplate
            });
            return screenTemplate;
        },
        onMutate: async (screenTemplate: string | null) => {
            await queryClient.cancelQueries({ queryKey: ['getDevice', deviceId] });

            const previousDevice = queryClient.getQueryData(['getDevice', deviceId]) as Device;

            queryClient.setQueryData(['getDevice', deviceId], (queryData: any) => {
                return Object.assign({}, queryData, { screenTemplate });
            });

            return { previousDevice };
        },
        onError: (error, variables, context) => {
            queryClient.setQueryData(['getDevice', deviceId], (queryData: any) => {
                return Object.assign({}, queryData, { screenTemplate: context?.previousDevice?.screenTemplate ?? null });
            });
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: ['getDevice', deviceId] });
        }
    });

    return mutation;
}
